import { render, staticRenderFns } from "./Four.vue?vue&type=template&id=40ee0322&scoped=true&"
import script from "./Four.vue?vue&type=script&lang=js&"
export * from "./Four.vue?vue&type=script&lang=js&"
import style0 from "./Four.vue?vue&type=style&index=0&id=40ee0322&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ee0322",
  null
  
)

export default component.exports